module.exports = __webpack_public_path__ + "img/normal.da98d393.gif";